import React from 'react';
import { string } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import { LEARN_MORE_TRACKER_POS } from '../../../../../shared/constants';
import { getBriefUrl } from '../../../../../shared/lib';
import { getStartedClicked } from '../../lib/bi-events';
import './style.scss';

const MakeNewLogo = ({ ctaTitle, ctaSubtitle, brandName, slogan, tagType, tagId }) => {
    const trackGetStartedClick = (elementText) =>
        getStartedClicked({
            elementText,
            elementPosition: LEARN_MORE_TRACKER_POS.mid,
            elementName: 'start now',
            pageTagType: tagType,
            pageTagId: tagId,
        });

    return (
        <div className="make-new-logo">
            <div className="content">
                <h2>{ctaTitle}</h2>
                <p>{ctaSubtitle}</p>
                <Button
                    className="make-new-logo-btn"
                    rel="nofollow"
                    color={Button.COLORS.BLUE}
                    onClick={() => trackGetStartedClick(translate('logo_maker_perseus.general.make_new_logo'))}
                    href={getBriefUrl({
                        brandName,
                        slogan,
                        tagType,
                        tagId,
                    })}
                >
                    <I18n k="logo_maker_perseus.general.make_new_logo" />
                </Button>
            </div>
            <div className="make-new-logo-bg">
                <div className="grid-12">
                    <div className="red col-6-xs col-4-sm col-3-md" />
                    <div className="blue col-6-xs col-4-sm col-3-md" />
                    <div className="green col-6-xs col-4-sm col-3-md" />
                    <div className="yellow col-6-xs col-4-sm col-3-md" />
                </div>
            </div>
        </div>
    );
};

MakeNewLogo.propTypes = {
    ctaTitle: string,
    ctaSubtitle: string,
    brandName: string,
    slogan: string,
    tagType: string,
    tagId: string,
};

export default MakeNewLogo;
